import { adaptEventListItem } from './eventListAdapter';
import type {
  EventApiDetailItem,
  EventDetailItem,
  EventTeaListItem,
} from '../../config';

export function adaptEventDetailItem(dto: EventApiDetailItem): EventDetailItem {
  const base = adaptEventListItem(dto);
  const teaList: EventTeaListItem[] = (dto.tea_list ?? []).map((item) => ({
    image: item.image,
    title: item.title,
  }));

  return {
    ...base,
    text: dto.text ?? '',
    tea_list: teaList,
    address: dto.address ?? '',
    seo_title: dto.seo_title ?? null,
    seo_description: dto.seo_description ?? null,
    seo_keywords: dto.seo_keywords ?? null,
  };
}
